module.exports = __webpack_public_path__ + "img/Playlist Wireframes.1e62153e.svg";